import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ApiCallService } from '../../core/services/api/api-call.service';
import { IWidgetConfiguration } from '../interfaces/widget';
import { IWidgetSendConfiguration } from '../interfaces/widget-send-configuration';

@Injectable({
  providedIn: 'root',
})
export class WidgetConfigurationService {
  public widgetChange$: Subject<IWidgetSendConfiguration>;
  public widgetConfigurationChange$: Subject<IWidgetConfiguration>;

  constructor(private apiCallService: ApiCallService) {
    this.widgetChange$ = new Subject<IWidgetSendConfiguration>();
    this.widgetConfigurationChange$ = new Subject<IWidgetConfiguration>();
  }

  public changeConfiguration(config: IWidgetSendConfiguration, instance: any): Promise<string> {
    return new Promise((resolve) => {
      const url = 'Component/EditComponent';
      this.apiCallService.post(url, config).then(
        () => {
          this.widgetChange$.next(config);
          instance.data = {
            ...instance.data,
            delay: config.delay,
            timeout: config.timeout,
            title: config.visibleName,
          };

          resolve('success');
        },
        () => resolve('error'),
      );
    });
  }
}
